import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type HotelSettingsCompetitorsBenchmarkRoute from 'lumen/routes/hotel/settings/competitors/benchmark';
import type { ModelFrom } from 'lumen/utils/routes';

export default class HotelSettingsCompetitorsBenchmarkCompsetRoute extends Route {
  @service declare access: Services['access'];
  @service('benchmark-insight/competitors/desired-compset')
  declare desiredCompsetService: Services['benchmark-insight/competitors/desired-compset'];
  @service declare router: Services['router'];

  beforeModel(): void {
    if (!this.access.hasCompsetBenchmark) {
      this.router.transitionTo('hotel.settings.competitors.benchmark');
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  model() {
    const parentModel = this.modelFor(
      'hotel.settings.competitors.benchmark',
    ) as ModelFrom<HotelSettingsCompetitorsBenchmarkRoute>;

    const model = {
      compset: parentModel.compset,
      desiredCompset: this.desiredCompsetService.desiredCompsetTask,
    };

    void model.desiredCompset.perform();

    return model;
  }
}
